'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeComment = function EditorModeComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
  );
};
EditorModeComment = (0, _pure2.default)(EditorModeComment);
EditorModeComment.displayName = 'EditorModeComment';

exports.default = EditorModeComment;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/mode-comment.js
 ** module id = 1464
 ** module chunks = 0
 **/